import React, {useCallback, useEffect, useRef, useState} from 'react'

import {InvisibleSmartCaptcha} from '@yandex/smart-captcha'

import {settings} from '@/src/config/settings'
import {isMobile, uuid} from '@/src/shared/utils/functions'
import {useUpdateEffect} from 'react-use'
import {AsyncProcessLoading} from '@/src/shared/ui/layout/ui/async-loading'

interface InvisibleCaptchaProps {
  visible: boolean
  setVisible: (visible: boolean) => void
  onSuccess: (token: string) => void
  renderKey: string
}

export const InvisibleCaptcha = ({
  visible,
  setVisible,
  onSuccess,
  renderKey,
}: InvisibleCaptchaProps) => {
  const [token, setToken] = useState('')
  const [rerenderKey, setRerenderKey] = useState(() => renderKey)

  const handleChallengeHidden = useCallback(() => setVisible(false), [])

  useEffect(() => {
    if (token) {
      onSuccess(token)
    }
  }, [token, visible])

  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    if (['test', 'development'].includes(settings.NEXT_PUBLIC_APP_ENV)) {
      setToken('TEST')
    }

    if (iframeRef.current) {
      window.addEventListener('message', event => {
        // Проверяем источник сообщения для безопасности
        if (event.origin !== settings.NEXT_PUBLIC_FRONTEND_URL) return

        if (event.data.type === 'captcha-token') {
          setToken(event.data.message)
        }
        if (event.data.type === 'captcha-hidden') {
          setRerenderKey(uuid())
        }
        if (event.data.type === 'captcha-error') {
          setRerenderKey(uuid())
        }
      })
    }
  }, [iframeRef.current])

  useUpdateEffect(() => {
    setRerenderKey(renderKey)
  }, [renderKey])

  if (['test', 'development'].includes(settings.NEXT_PUBLIC_APP_ENV)) return <></>

  return (
    <>
      {!token && <AsyncProcessLoading />}
      {(!isMobile() && (
        <InvisibleSmartCaptcha
          key={renderKey}
          sitekey={settings.Y_CAPTCHA_KEY!}
          onSuccess={setToken}
          onChallengeHidden={handleChallengeHidden}
          visible={visible}
        />
      )) ||
        (!token && (
          <iframe
            key={`${rerenderKey}-${renderKey}`}
            style={{
              position: 'fixed',
              left: 0,
              top: 0,
              zIndex: 3000,
              background: 'transparent',
            }}
            ref={iframeRef}
            src={`${settings.NEXT_PUBLIC_FRONTEND_URL}/smart-captcha/?sitekey=${settings.Y_CAPTCHA_KEY}`}
            frameBorder="0"
            width="100%"
            height="100%"
          />
        ))}
    </>
  )
}
